import initKycMFEApiService from 'components/KycMFE/initKycMFEApiService';
import initDatabasesMFEApiService from '../../components/DatabasesMFE/initDatabasesMFEApiService';
import initRdiMFEApiService from '../../components/RdiMFE/initRdiMFEApiService';
import initSubscriptionsMFEApiService from '../../screens/SubscriptionsAndDatabases/Subscriptions/SubscriptionsMFE/initSubscriptionsMFEApiService';
import initLangCacheMFEApiService from '../../components/LangcacheUIMFE/initLangCacheMFEApiService';

const initMfesApiServices = () => {
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  Promise.all([
    initDatabasesMFEApiService(),
    initRdiMFEApiService(),
    initSubscriptionsMFEApiService(),
    initLangCacheMFEApiService(),
    initKycMFEApiService()
  ]);
};

export default initMfesApiServices;
